import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Polizza } from 'src/app/models/polizza';
import { SommaAssicurata } from 'src/app/models/somma-assicurata';
import { PolizzaService } from 'src/app/services/polizza.service';
import { SommaAssicurataService } from 'src/app/services/somma-assicurata.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { findInRoute } from 'src/app/shared/utilities';
import { SommaAssicurataFormComponent } from './form/form.component';

@Component({
  selector: 'somme-assicurate',
  templateUrl: './somme-assicurate.component.html',
  styleUrls: ['./somme-assicurate.component.scss']
})
export class SommeAssicurateComponent implements OnInit {

  @Input() heading = true;

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Valore',
        internalName: 'valore',
        type: 'currency',
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Deroga',
        type: 'percentage',
        internalName: 'deroga_percentuale',
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Valore con deroga',
        type: 'currency',
        sortDisabled: true,
        internalName: 'valore_con_deroga',
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Descrizione',
        internalName: 'descrizione',
      }
    ),
  ];
  constructor(public sommaAssicurataService: SommaAssicurataService,
    private toast: ToastrService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private polizzaService: PolizzaService,) {

  }


  @Input() polizza: Polizza;

  async ngOnInit() {

    if (!this.polizza) { //if polizza is not given as input, search in url
      const idPolizza = findInRoute('idPolizza', this.route)

      if (idPolizza) { //if found in url, fetch from server
        this.polizza = await this.polizzaService.getOne(+idPolizza);
      }
      else throw "Impossibile cercare le somme assicurate: id polizza mancante"; //if not found, throw error.

    }

    this.updateDataSource();
  }



  add() {
    let addDialogRef = this.dialog.open(SommaAssicurataFormComponent, { data: { polizza: this.polizza } });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(sommaAssicuratas) {
    if (sommaAssicuratas) {
      try {
        await this.sommaAssicurataService.create(sommaAssicuratas)
        this.toast.success('Somma assicurata creata')
      }
      catch (e) {
        this.toast.error('Creazione somma assicurata fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }


  editFunction = async (sommaAssicurata: SommaAssicurata) => {
    let dialogRef = this.dialog.open(SommaAssicurataFormComponent, { data: { sommaAssicurata: sommaAssicurata, polizza: this.polizza } });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        Object.assign(sommaAssicurata, res);
        try {
          await this.sommaAssicurataService.edit(sommaAssicurata);
          this.toast.success('Somma assicurata modificata');
        }
        catch (e) {
          console.error(e);
        }
        finally {
          this.updateDataSource();
        }
      }
    });
  }

  deleteFunction = async (sommaAssicurata: SommaAssicurata) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la somma assicurata ${sommaAssicurata.humanIdentifier}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.sommaAssicurataService.delete(sommaAssicurata);
          this.toast.success('Somma assicurata eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione somma assicurata fallita.", "Errore!");
    }
  }


  applyIntrinsicConstraints() {
    this.search = { polizza_id: this.polizza?.id };
  }

  async updateDataSource() {
    this.applyIntrinsicConstraints();
  }

  @Output() newModelsLoaded = new EventEmitter();
  emitNewModelsLoaded() {
    this.newModelsLoaded.emit();
  }


  get sommeAssicurate(): SommaAssicurata[] {
    return this.index?.models as SommaAssicurata[];
  }
}
